import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement } from '@/tracking';

export const SustainabilityWidget: FC = () => {
  const texts = useTexts();

  return (
    <Container>
      <Title>{texts.news.assets.sustainability.title}</Title>
      <img
        alt="Sustainable city illustration"
        title="Sustainable city illustration"
        src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/sustainable-city.svg`}
      />
      <Button
        as="a"
        variant="subtle"
        href={texts.news.assets.sustainability.link}
        rel="noreferrer"
        target="_blank"
        // We can't use `getTrackId` here because it adds the page name to the track-id.
        // This widget is only used in the menu and we don't want the track-ids in the menu
        // to change for every page change, therefor we're using `menu` to describe placement.
        data-trackid={`${TrackingElement.Link}_go-to-news-assets-sustainability_menu`}
      >
        {texts.news.assets.sustainability.buttonLabel}
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  padding: 48px;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 2rem;
  line-height: 2.5rem;
  font-family: 'Storebrand Display', sans-serif;
  font-weight: 600;

  margin-top: 0;
  text-align: center;
  width: 400px;
`;
